export { default } from './FaresCarouselBackgroundImageContainerMobile';
